import { Component } from '@angular/core';
import { ReferralsComponent } from './referrals.component';

@Component({
  selector: 'eid-referrals-desktop',
  templateUrl: './referrals.desktop.component.html',
  styleUrls: ['./referrals.desktop.component.scss']
})
export class ReferralsDesktopComponent extends ReferralsComponent {}
